"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmenuSectionTitle = exports.SubmenuSection = exports.SectionDivider = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Clamp = _interopRequireDefault(require("../../../../components/Clamp"));
const SubmenuSectionTitle = exports.SubmenuSectionTitle = (0, _styledComponents.default)(_Clamp.default).withConfig({
  displayName: "styles__SubmenuSectionTitle",
  componentId: "sc-1li67bg-0"
})(["color:", ";font-family:", ";font-size:", ";font-weight:", ";letter-spacing:", ";line-height:", ";text-transform:", ";opacity:", ";"], ({
  theme
}) => theme.colors.appFrame.menu.submenuSectionTitleColor, ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.AppFrame.menu.submenu.sectionFontSize, ({
  theme
}) => theme.AppFrame.menu.submenu.sectionFontWeight, ({
  theme
}) => theme.AppFrame.menu.submenu.sectionLetterSpacing, ({
  theme
}) => theme.AppFrame.menu.submenu.sectionLineHeight, ({
  theme
}) => theme.AppFrame.menu.submenu.sectionTextTransform, ({
  theme
}) => theme.AppFrame.menu.submenu.sectionTitleOpacity);
const SubmenuSection = exports.SubmenuSection = _styledComponents.default.a.withConfig({
  displayName: "styles__SubmenuSection",
  componentId: "sc-1li67bg-1"
})(["display:block;padding:", ";cursor:pointer;&:hover{background-color:", ";", "{opacity:1;color:", ";}}"], ({
  theme
}) => theme.AppFrame.menu.submenu.sectionPadding, ({
  theme
}) => theme.colors.appFrame.menu.itemHoverBg, SubmenuSectionTitle, ({
  theme
}) => theme.colors.appFrame.menu.itemTextHover);
const SectionDivider = exports.SectionDivider = _styledComponents.default.hr.withConfig({
  displayName: "styles__SectionDivider",
  componentId: "sc-1li67bg-2"
})(["background-color:", ";margin:0 16px;height:", ";opacity:0.3;"], ({
  theme
}) => theme.colors.appFrame.menu.submenuDivider, ({
  theme
}) => theme.AppFrame.menu.submenu.dividerHeight);